export const UI_STATE_DIRTY_FIELDS = '__dirty'
